module.exports = __webpack_public_path__ + "media/images/new_culture/bg-1-ef73b0052c80ca3972366a6f6e314f41.jpeg";